import {
    GET_PAYMENT_METHODS,
    ADD_PAYMENT_METHOD,
    REMOVE_PAYMENT_METHOD,
    CLEAR_PAYMENT_METHODS,
} from "../actions/types";

const paymentmethods = (state = [], action) => {
    switch (action.type) {
        case GET_PAYMENT_METHODS:
            return action.payload;
        case ADD_PAYMENT_METHOD:
            return [...state, action.payload];
        case REMOVE_PAYMENT_METHOD:
            return state.filter((pm) => pm.id != action.payload);
        case CLEAR_PAYMENT_METHODS:
            return [];
        default:
            return state;
    }
};

export default paymentmethods;
